import { render } from "./voiceProfileSidebar.vue?vue&type=template&id=1f302519"
import script from "./voiceProfileSidebar.vue?vue&type=script&lang=js"
export * from "./voiceProfileSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__